module.exports = __webpack_public_path__ + "static/media/1.8.2_manual.721a04cf.png";